import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiTableCell(theme: Theme): MuiThemeComponentOverride<"MuiTableCell"> {
  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.brand.orange[100].light}`,
          padding: "12px",

          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
          "&:empty": {
            borderBottom: `1px solid ${theme.palette.brand.grey[100].main}`,
          },
        },
      },
    },
  };
}
